<template>
  <confirm-modal ref="modal">
    <template slot="body">
      <p>Deseja realmente remover o cartão {{ card }}? </p>
    </template>
  </confirm-modal>
</template>

<script>
import ConfirmModal from '@/support/components/modal/ConfirmModal.vue';

export default {
  name: 'ConfirmDetachPaymentMethod',

  props: ['card'],

  methods: {
    /**
     * Confirm the change endpoint name.
     *
     * @returns {Promise<boolean>}
     */
    confirm() {
      return this.$refs.modal.confirm();
    },
  },

  computed: {
  },

  components: {
    ConfirmModal,
  },
};
</script>

<style lang="scss" scoped>

</style>
